import * as React from 'react'

import { Container, ContentContainer, StyledTitle } from './PageContent.styles'
import { BackgroundColor, Padding } from './types'

interface IProps {
  backgroundColor: BackgroundColor
  children: React.ReactNode
  padding: Padding | null
  title?: string
}

export default function PageContent(props: IProps) {
  const { backgroundColor, children, padding, title } = props

  return (
    <Container backgroundColor={backgroundColor} padding={padding}>
      <ContentContainer>
        {title && <StyledTitle kind="large">{title}</StyledTitle>}
        {children}
      </ContentContainer>
    </Container>
  )
}

PageContent.defaultProps = {
  backgroundColor: BackgroundColor.WhiteDove,
  padding: Padding.Normal,
}
